import { createFileRoute, Navigate } from '@tanstack/react-router';
import { orgRoute } from '@/app/org-route';

// /admin/users → /settings?section=users. Old deep links keep working.
export const Route = createFileRoute('/$orgId/admin/users')({
  component: () => (
    <Navigate to={orgRoute('/settings')} search={{ section: 'users' }} replace />
  ),
});
